// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"289c30dccc1a129dfb6b","293":"0b774ca7990f720b9f23","518":"17788081e419e01c7eee","779":"503c079e13c39a3cada2"}[chunkId] + ".js";
};